import store from "../../Store";

export const StoreData = () => store.getState();

export const dispatch = () => store.dispatch;
